export var BenefitBannerVariant;
(function (BenefitBannerVariant) {
    BenefitBannerVariant["MULTI_BENEFITS"] = "multiBenefits";
    BenefitBannerVariant["HEALTH_LIFE"] = "heathLife";
    BenefitBannerVariant["EXPENSES"] = "expenses";
    BenefitBannerVariant["FLEET"] = "fleet";
})(BenefitBannerVariant || (BenefitBannerVariant = {}));
//# sourceMappingURL=BenefitBanner.types.js.map